var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"6","viewBox":"0 0 12 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 0H0L4.58579 4.58579C5.36684 5.36684 6.63317 5.36683 7.41421 4.58579L12 0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }